<!--
  Kommerzielle Landingpage „Kartoffelautomat kaufen“. Muster wie die übrigen
  Cluster-Seiten. Spielerei: hüpfende Kartoffel (Squash & Stretch) mit Schatten.
-->
<section class="kta-hero">
  <div class="content content--wide kta-hero__grid">
    <div class="kta-hero__text reveal">
      <!-- Hüpfende Kartoffel (reine CSS/SVG, reduced-motion-sicher). Dekorativ → aria-hidden. -->
      <div class="kta-potato" aria-hidden="true">
        <svg viewBox="0 0 100 100" role="img">
          <ellipse class="kta-potato__shadow" cx="50" cy="86" rx="20" ry="4" />
          <g class="kta-potato__body">
            <ellipse cx="50" cy="52" rx="26" ry="20" transform="rotate(-18 50 52)" />
            <circle class="kta-potato__eye" cx="42" cy="46" r="1.8" />
            <circle class="kta-potato__eye" cx="55" cy="50" r="1.6" />
            <circle class="kta-potato__eye" cx="49" cy="58" r="1.5" />
          </g>
        </svg>
      </div>
      <span class="kta-eyebrow" i18n="@@kta.hero.eyebrow">Direktvermarktung · 24/7</span>
      <h1 class="title display" i18n="@@kta.hero.h1">Kartoffelautomat kaufen</h1>
      <div class="line"></div>
      <p class="kta-lead" i18n="@@kta.hero.lead">
        Verkaufe Kartoffeln und Feldfrüchte rund um die Uhr – am Feldrand oder direkt ab Hof,
        ohne Personal vor Ort. Die <span class="tm">marktbox</span> ist dein Kartoffelautomat für die
        Direktvermarktung: bargeldlos, app-gesteuert und skalierbar.
      </p>
      <div class="kta-cta">
        <a class="btn btn-primary kta-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@kta.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="kta-cta__ghost" href="#preise" (click)="scrollTo($event, 'preise')" i18n="@@kta.hero.ctaGhost">Kaufen oder mieten? ↓</a>
      </div>
    </div>
    <figure class="kta-hero__media reveal">
      <img src="assets/headers/marktbox-03-1440.webp"
        alt="marktbox Kartoffelautomat am Feldrand für die Direktvermarktung" i18n-alt="@@kta.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="kta-hero__badge" i18n="@@kta.hero.badge">🥔 direkt vom Feld</span>
    </figure>
  </div>
</section>

<!-- ===== Vorteile ===== -->
<section class="kta-section">
  <div class="content content--wide">
    <h2 class="kta-h2 reveal" i18n="@@kta.adv.h2">Warum die marktbox als Kartoffelautomat?</h2>
    <div class="kta-grid">
      <div class="kta-card reveal">
        <span class="kta-card__ico">🕒</span>
        <h3 i18n="@@kta.adv.c1.h">24/7 verkaufen</h3>
        <p i18n="@@kta.adv.c1.p">Deine Kundschaft kauft frische Kartoffeln, wann sie will – auch abends, sonntags und feiertags.</p>
      </div>
      <div class="kta-card reveal">
        <span class="kta-card__ico">💳</span>
        <h3 i18n="@@kta.adv.c2.h">Bargeldlos &amp; app-gesteuert</h3>
        <p i18n="@@kta.adv.c2.p">Kartenzahlung am Automaten, Fernwartung und Füllstände per App – ohne täglichen Aufwand vor Ort.</p>
      </div>
      <div class="kta-card reveal">
        <span class="kta-card__ico">🧺</span>
        <h3 i18n="@@kta.adv.c3.h">Große Fächer</h3>
        <p i18n="@@kta.adv.c3.p">Von der kleinen Kartoffelschale bis zum 5-kg-Sack – ob Netz oder Tüte, beides passt in deine marktbox.</p>
      </div>
      <div class="kta-card reveal">
        <span class="kta-card__ico">🚜</span>
        <h3 i18n="@@kta.adv.c4.h">Direkt am Feld</h3>
        <p i18n="@@kta.adv.c4.p">Verkaufe ohne Zwischenhandel dort, wo geerntet wird – mit voller Kontrolle über den Preis.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Live-Link ===== -->
<section class="kta-section kta-live">
  <div class="content content--wide kta-live__grid">
    <div class="kta-live__text reveal">
      <span class="kta-eyebrow" i18n="@@kta.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="kta-h2" i18n="@@kta.live.h2">Sieh, was gerade in der Box ist</h2>
      <p class="kta-lead" i18n="@@kta.live.lead">
        Jede marktbox hat ihren eigenen Live-Link: Deine Kundschaft sieht in Echtzeit, welche
        Sorten und Gebinde gerade verfügbar sind – noch bevor sie losfährt. Das schafft Vertrauen,
        spart unnötige Wege und bringt mehr Verkäufe.
      </p>
      <ul class="kta-live__list">
        <li i18n="@@kta.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@kta.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@kta.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="kta-cta">
        <a class="btn btn-primary kta-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@kta.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link: Echtzeit-Verfügbarkeit der Kartoffel-Box" i18n-title="@@kta.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@kta.live.cap">Live-Beispiel: Kartoffel Müller</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Preise ===== -->
<section id="preise" class="kta-section kta-section--muted">
  <div class="content content--wide">
    <h2 class="kta-h2 reveal" i18n="@@kta.price.h2">Kartoffelautomat kaufen oder mieten</h2>
    <div class="kta-price-grid">
      <div class="kta-price reveal">
        <span class="kta-price__label" i18n="@@kta.price.buyLabel">Kaufen</span>
        <span class="kta-price__value" i18n="@@kta.price.buyValue">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@kta.price.buyP">Einmalige Investition, dauerhaft dein Automat – ideal für den langfristigen Betrieb.</p>
      </div>
      <div class="kta-price reveal">
        <span class="kta-price__label" i18n="@@kta.price.rentLabel">Mieten</span>
        <span class="kta-price__value" i18n="@@kta.price.rentValue">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@kta.price.rentP">Niedrige Einstiegshürde, planbare monatliche Kosten – ideal zum Starten und Testen.</p>
      </div>
    </div>
    <div class="kta-cta kta-cta--center reveal">
      <a class="btn btn-primary kta-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@kta.price.cta">Zum Shop – Kartoffelautomat konfigurieren</a>
    </div>
    <p class="kta-fineprint reveal" i18n="@@kta.price.fineprint">
      Noch unsicher?
      <a [routerLink]="['/', links.blog, blogSlug]">Im Ratgeber: Wege der landwirtschaftlichen Direktvermarktung</a>
    </p>
  </div>
</section>

<!-- ===== Modelle ===== -->
<section class="kta-section">
  <div class="content content--wide">
    <h2 class="kta-h2 reveal" i18n="@@kta.models.h2">Passende Modelle</h2>
    <div class="kta-models">
      <a class="kta-model reveal" [routerLink]="['/', links.shop, 'marktbox-39']">
        <figure class="kta-model__media">
          <img src="assets/rendered/39/webp/frame-0035.webp" alt="marktbox 39 – Kartoffelautomat mit 39 Fächern" i18n-alt="@@kta.models.m39.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="kta-model__body">
          <h3>marktbox 39</h3>
          <p i18n="@@kta.models.m39.p">39 Fächer – für viele Sorten und Gebindegrößen.</p>
          <span class="kta-model__more" i18n="@@kta.models.more">Modell ansehen →</span>
        </div>
      </a>
      <a class="kta-model reveal" [routerLink]="['/', links.shop, 'marktbox-24']">
        <figure class="kta-model__media">
          <img src="assets/rendered/24/webp/frame-0035.webp" alt="marktbox 24 – kompakter Kartoffelautomat mit 24 Fächern" i18n-alt="@@kta.models.m24.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="kta-model__body">
          <h3>marktbox 24</h3>
          <p i18n="@@kta.models.m24.p">24 Fächer – kompakter Einstieg für den Verkauf am Feldrand.</p>
          <span class="kta-model__more" i18n="@@kta.models.more2">Modell ansehen →</span>
        </div>
      </a>
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="kta-section kta-section--muted">
  <div class="content content--wide">
    <h2 class="kta-h2 reveal" i18n="@@kta.faq.h2">Häufige Fragen zum Kartoffelautomat</h2>
    <div class="kta-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="kta-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
    <p class="kta-fineprint reveal" i18n="@@kta.faq.fineprint">
      Mehr Praxiswissen im Ratgeber:
      <a [routerLink]="['/', links.blog, blogSlug]">Wege der landwirtschaftlichen Direktvermarktung</a>.
    </p>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="kta-section kta-final reveal">
  <div class="content content--wide">
    <h2 class="kta-h2" i18n="@@kta.final.h2">Bereit für deinen Kartoffelautomaten?</h2>
    <p class="kta-lead" i18n="@@kta.final.lead">Finde dein Modell, wähle kaufen oder mieten und starte in die Direktvermarktung.</p>
    <div class="kta-cta kta-cta--center">
      <a class="btn btn-primary kta-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@kta.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
